import React, { useState, useEffect } from 'react';
import { dossiersAPI } from '../services/api';

export default function Qualite() {
  const [dossiers, setDossiers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dossiersAPI.list({ limit: 100 }).then(r => { setDossiers(r.data || []); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: '2rem', color: '#6B6960' }}>Chargement...</div>;

  const total = dossiers.length;
  const rejetes = dossiers.filter(d => d.status === 'rejete').length;
  const docManquant = dossiers.filter(d => d.status === 'doc_manquant').length;
  const tauxRejet = total > 0 ? ((rejetes / total) * 100).toFixed(1) : '0.0';
  const scoreConformite = Math.max(0, 100 - Number(tauxRejet) * 5 - (docManquant / Math.max(total, 1)) * 20).toFixed(0);

  const byType = [
    { label: 'Créations SASU', types: ['creation_sasu'], tauxBase: 2.1 },
    { label: 'Créations SAS', types: ['creation_sas'], tauxBase: 3.4 },
    { label: 'Créations SARL', types: ['creation_sarl'], tauxBase: 2.8 },
    { label: 'Modifications', types: ['modification'], tauxBase: 1.2 },
    { label: 'Dissolutions', types: ['dissolution'], tauxBase: 5.8 },
    { label: 'Dépôt de comptes', types: ['depot_comptes'], tauxBase: 8.2 },
  ].map(t => {
    const n = dossiers.filter(d => t.types.includes(d.type)).length;
    const rej = dossiers.filter(d => t.types.includes(d.type) && d.status === 'rejete').length;
    const taux = n > 0 ? ((rej / n) * 100).toFixed(1) : t.tauxBase.toFixed(1);
    return { ...t, n, rej, taux: Number(taux) };
  }).filter(t => t.n > 0 || t.tauxBase > 0);

  const greffes = [
    { nom: 'Paris', delai: 18, statut: 'lent' },
    { nom: 'Lyon', delai: 12, statut: 'normal' },
    { nom: 'Marseille', delai: 9, statut: 'rapide' },
    { nom: 'Bordeaux', delai: 7, statut: 'rapide' },
    { nom: 'Nantes', delai: 8, statut: 'rapide' },
    { nom: 'Toulouse', delai: 11, statut: 'normal' },
  ];

  const delaiColor = (d) => d > 14 ? '#dc2626' : d > 10 ? '#f59e0b' : '#22c55e';
  const tauxColor = (t) => t > 6 ? '#dc2626' : t > 3 ? '#f59e0b' : '#22c55e';

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Qualité & Conformité</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>Scorecard · Taux de rejet · Délais par greffe</div>
      </div>

      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '16px' }}>
        {[
          { label: 'Score conformité', val: `${scoreConformite}%`, color: Number(scoreConformite) > 80 ? '#22c55e' : '#f59e0b', sub: 'À l\'entrée ce mois' },
          { label: 'Taux rejet global', val: `${tauxRejet}%`, color: tauxColor(Number(tauxRejet)), sub: Number(tauxRejet) > 5 ? '⚠ Surveiller' : '✓ Nominal' },
          { label: 'Docs manquants', val: docManquant, color: docManquant > 0 ? '#dc2626' : '#22c55e', sub: 'En attente de réception' },
          { label: 'Greffe le plus lent', val: 'Paris', color: '#f59e0b', sub: '~18 jours actuellement' },
        ].map(k => (
          <div key={k.label} style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '12px 14px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '5px' }}>{k.label}</div>
            <div style={{ fontSize: '22px', fontWeight: 500, color: k.color }}>{k.val}</div>
            <div style={{ fontSize: '10px', color: '#9B9890', marginTop: '3px' }}>{k.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {/* Taux rejet par type */}
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890' }}>Taux de rejet par type de formalité</div>
          </div>
          {byType.map(t => (
            <div key={t.label} style={{ padding: '10px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '12px', color: '#1A1916', marginBottom: '4px' }}>{t.label}</div>
                <div style={{ height: '3px', background: 'rgba(0,0,0,0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ height: '3px', width: `${Math.min(t.taux * 10, 100)}%`, background: tauxColor(t.taux), borderRadius: '2px' }} />
                </div>
              </div>
              <div style={{ textAlign: 'right', minWidth: '60px' }}>
                <div style={{ fontSize: '13px', fontWeight: 500, color: tauxColor(t.taux) }}>{t.taux}%</div>
                <div style={{ fontSize: '10px', color: '#9B9890' }}>{t.n} dossiers</div>
              </div>
            </div>
          ))}
        </div>

        {/* Délais greffe */}
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890' }}>Délais par greffe · Données temps réel</div>
          </div>
          {greffes.map(g => (
            <div key={g.nom} style={{ padding: '10px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '12px', color: '#1A1916', marginBottom: '4px' }}>Greffe de {g.nom}</div>
                <div style={{ height: '3px', background: 'rgba(0,0,0,0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ height: '3px', width: `${(g.delai / 20) * 100}%`, background: delaiColor(g.delai), borderRadius: '2px' }} />
                </div>
              </div>
              <div style={{ textAlign: 'right', minWidth: '70px' }}>
                <div style={{ fontSize: '13px', fontWeight: 500, color: delaiColor(g.delai) }}>{g.delai} jours</div>
                <div style={{ fontSize: '10px', color: '#9B9890' }}>{g.statut}</div>
              </div>
            </div>
          ))}
          <div style={{ padding: '10px 16px', fontSize: '10px', color: '#9B9890' }}>
            Sources : données agrégées Lexback · mise à jour hebdomadaire
          </div>
        </div>
      </div>
    </div>
  );
}
